// Renderer registry.
//
// Maps an auditType slug to the React component responsible for displaying
// records of that audit type. The FindingsShell looks up the right component
// here, falls back to DefaultTable when no entry exists.
//
// Adding a new audit type's custom layout = one import + one map entry.

import DefaultTable from './DefaultTable';
import ServiceLines from './ServiceLines';

const REGISTRY = {
  'FINANCE-CONTRACT-BALANCE-DATTO':   ServiceLines,
  // Future: as Test- scripts move over, add their renderers here.
  // 'FINANCE-CONTRACT-BALANCE-SHERWEB': ServiceLines,
  // 'OPERATIONS-SONICWALL-CONFIG':      DeviceList,
  // 'OPERATIONS-UNIFI-CONFIG':          DeviceList,
};

export function rendererFor(auditType) {
  return REGISTRY[auditType] || DefaultTable;
}

export { DefaultTable, ServiceLines };
